import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { RouteAction } from '@core/action/action';
import { AuthenticationService } from '@core/auth/authentication.service';
import { TipoEntidadeEnum } from '@core/models/entidade';
import { PerfilEnum } from '@core/models/perfil';
import { TipoVinculoEnum } from '@core/models/vinculo';
import { AreaAtuacaoService } from '@core/services/areaAtuacaoService';
import { CargoReferenciaService } from '@core/services/cargoreferencia.service';
import { EntidadesService } from '@core/services/entidades.service';
import { FormService } from '@core/services/form.service';
import { LotacaoService } from '@core/services/lotacaoService';
import { MessageService } from '@core/services/message.service';
import { NotificationService } from '@core/services/notification.service';
import { ParametrizacaoService } from '@core/services/parametrizacao.service';
import { PessoaService } from '@core/services/pessoa.service';
import { SituacaoEntidadeService } from '@core/services/situacaoentidade.service';
import { StatusValidacaoService } from '@core/services/status.validacao.service';
import { TipoEntidadeService } from '@core/services/tipoentidade.service';
import { VinculoService } from '@core/services/vinculo.service';
import { VinculoSharedDataService } from '@modules/vinculo/vinculo-shared-data.service';
import {
  addFormControls,
  clearCamposObrigatorios,
  dataComDigitacao,
  validarCamposObrigatorios,
  validarCamposObrigatoriosAjuste,
} from '@shared/util/util';
import { DebouncedSearch } from '@shared/util/debounced-search.util';
import { filtrarOpcaoSemAcento } from '@shared/util/accent-insensitive-filter.util';
import dayjs from 'dayjs';
import { forkJoin, Subject, takeUntil, distinctUntilChanged } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-dados-basico-vinculo-form',
  templateUrl: './dados-basico-vinculo-form.component.html',
  styleUrls: ['./dados-basico-vinculo-form.component.scss'],
})
export class DadosBasicoVinculoFormComponent implements OnInit, OnChanges {
  nzFilterOption = (): boolean => true;
  filtrarOpcaoSemAcento = filtrarOpcaoSemAcento;
  private destroy$ = new Subject<void>();
  private readonly buscaPessoaDebounced = new DebouncedSearch();
  private readonly buscaEntidadeDebounced = new DebouncedSearch();
  private listasCarregadas = false;
  private ultimaPessoaComboId: number | null = null;
  private formSubscriptionsProntas = false;
  /** Enquanto hidrata o form na edição, não dispara validar-datas / side-effects. */
  private hidratandoFormulario = false;
  private tipoVinculoListCompleta: any[] | null = null;
  carregandoCargos = false;
  carregandoListas = true;
  carregandoCombosPessoa = false;
  carregandoLotacoes = false;

  @Input() isModal: boolean = false;
  @Input() vinculoForm!: FormGroup;
  @Input() vinculo: any;
  @Output() dadosBasicosEmit = new EventEmitter<any>();

  entidadeList: any[] = [];
  pessoaList: any[] = [];
  tipoVinculoList: any[] = [];
  cargoPessoaVinculoList: any[] = [];
  nomeFederacaoList: any[] = [];
  entidadeRepresentadaList: any[] = [];
  cagoPessoaEntidadeRepresentadaList: any[] = [];
  vinculoPessoaCargoEfetivoList: any[] = [];
  statusValidacaoList: any[] = [];
  nomePessoaList: any[] = [];
  vinculosVigenteList: any[] = [];
  vinculosEfetivosList: any[] = [];
  cargoVinculosList: any[] = [];
  cargoSuplentVinculosList: any[] = [];
  areaDeAtuacaoList: any[] = [];
  lotacaoList: any[] = [];
  entidadeRepresentanteList: any[] = [];
  cargoPessoaEntidadeRepresentadaList: any[] = [];
  idVinculo: any;
  tipoVinculoEnum = TipoVinculoEnum;
  isShowJustificativa: boolean = false;
  routeActionEnum = RouteAction;
  entidadeAndTipoEntidade: any;
  mostrarCargoSuplente: boolean = false;
  suplentesLista: any[] = [];
  disableJustificativa: boolean = false;
  tipoEntidadeIdSelecionada: any;
  isHiddenFieldsMandato: boolean = true;
  isHiddenFieldsPermanente: boolean = true;
  isHiddenFieldsTemporario: boolean = true;
  isHiddenFieldsMandatoComissaoSubComissaoGrupoTrabalho: boolean = true;
  isHiddenFieldsTemporarioComissaoSubComissaoGrupoTrabalho: boolean = true;
  isHiddenFieldsPermanenteComissaoSubComissaoGrupoTrabalho: boolean = true;
  isEntidadeOrgaoEvinculoLocatao: boolean = true;
  isComissaoSubcomissaoGrupoTrabalho: boolean = true;
  isEstatutario: boolean = true;
  mostrarCampoEstatutario: boolean = false;
  tipoEntidadeList: Array<{ id: number; nomeTipoEntidade?: string }> = [];
  entidadeSemCargos: boolean = false;
  isHiddenFieldsMandatoOrgao: boolean = true;
  isHiddenFieldsPermanentOrgao: boolean = true;
  isHiddenFieldsLotacao: boolean = true;
  isHiddenFieldsPermanenteAssociados: boolean = true;
  isHiddenFieldsTemporarioAssociados: boolean = true;
  requiredFieldsList: any[] = [];
  isShowJustificativaFimVinculo: boolean = false;
  isShowJustificativaFimMandato: boolean = false;
  fimVinculo: string | null = null;
  fimMandato: string | null = null;
  isCaptured: boolean = false;
  isFormInitialized: boolean = false;
  acao!: RouteAction;
  acaoEnum = RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  actionActual!: RouteAction;

  statusValidacao: any;
  campoEstatuario: boolean = false;
  perfilUsuarioLogado: any;
  isHiddenAreaAtuacao: boolean = true;
  vinculoEfetivoSuplente: any;
  tipoDoVinculoSelecionado: any;
  isPrincipal: boolean = true;

  constructor(
    private vinculoSharedDataService: VinculoSharedDataService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private situacaoEntidadeService: SituacaoEntidadeService,
    private pessoaService: PessoaService,
    private statusValidacaoService: StatusValidacaoService,
    private vinculoService: VinculoService,
    private entidadeService: EntidadesService,
    private areaAtuacaoService: AreaAtuacaoService,
    private formService: FormService,
    private notificationService: NotificationService,
    private cargoReferenciaService: CargoReferenciaService,
    private cdr: ChangeDetectorRef,
    private authenticationService: AuthenticationService,
    private parametrizacaoService: ParametrizacaoService,
    private lotacaoService: LotacaoService,
    private tipoEntidadeService: TipoEntidadeService,
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.isCaptured) {
        this.fimMandato = this.dataFimMandatoControl?.value;
        this.fimVinculo = this.dataFimVinculoControl?.value;
        this.isCaptured = true;
        this.isFormInitialized = true;
        console.log('Capturado uma vez no carregamento inicial:', {
          fimMandato: this.fimMandato,
          fimVinculo: this.fimVinculo,
        });
      }
    }, 500);

    this.regraEstatutario();
  }

  ngOnInit(): void {
    this.checkUrl();
    this.isPerfilUsuarioLogado();
    this.monitorarMudancasCargoReferencia();
    this.registrarSubscriptionsFormulario();
    this.regrasDeTipoVinulo();

    // Combos depois do primeiro paint: cargo, datas e justificativa aparecem antes.
    setTimeout(() => {
      this.tipoEntidadeService.listar().subscribe((data) => {
        this.tipoEntidadeList = data ?? [];
        this.regraEstatutario();
      });
      this.carregarListas();

      const idEntidade = this.vinculoForm.get('entidadeId')?.value ?? null;
      if (idEntidade && !this.vinculo) {
        this.selectCargos(idEntidade);
        if (this.isModal) {
          this.regraTipoEntidade(idEntidade);
        }
      }
    });
  }

  /** Subscriptions uma única vez — evita tempestade de GETs no ngOnChanges/patchValue. */
  private registrarSubscriptionsFormulario(): void {
    if (this.formSubscriptionsProntas || !this.vinculoForm) {
      return;
    }
    this.formSubscriptionsProntas = true;

    this.vinculoForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.regraEstatutario();
      });

    this.pessoaIdControl?.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(),
        filter((value) => value != null && value !== '')
      )
      .subscribe((value) => {
        if (this.hidratandoFormulario) {
          return;
        }
        if (typeof value === 'number') {
          this.carregarCombosPessoas(value);
        }
        // Não busca por label/string — evita GET /pessoa/{nome} e combo desnecessária no load
      });

    this.dataFimVinculoControl?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((dataFim) => {
        if (this.hidratandoFormulario) {
          return;
        }
        if (dataFim) {
          this.validarDatasVinculo();
          this.validarLimiteDatas();
        }
      });

    this.dataInicioVinculoControl?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((dataFim) => {
        if (this.hidratandoFormulario) {
          return;
        }
        if (dataFim) {
          this.validarLimiteDatas();
        }
      });

    this.cargoReferenciaIdsControl?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((val) => {
        this.possuiCargoSuplenteSelecionado(val)
          ? validarCamposObrigatorios(
              ['vinculoEfetivoSuplenteId'],
              this.vinculoForm,
            )
          : clearCamposObrigatorios(
              ['vinculoEfetivoSuplenteId'],
              this.vinculoForm,
            );
      });

    this.entidadeRepresentadaIdControl?.valueChanges
      .pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .subscribe((val) => {
        if (!val) {
          this.vinculoForm.get('cargoPessoaEntidadeRepresentada')?.reset();
          return;
        }
        if (typeof this.pessoaIdControl?.value === 'number') {
          this.vinculoService
            .buscarPorPessoaEntidadeRepresentada(this.pessoaIdControl?.value, val)
            .subscribe(
              (data) =>
                this.cargoPessoaEntidadeRepresentadaControl?.setValue(
                  data?.nome ?? null,
                ),
              () => this.cargoPessoaEntidadeRepresentadaControl?.reset(),
            );
        }
      });

    this.dataEmMandato();

    this.entidadeIdControl?.valueChanges
      .pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .subscribe((val) => {
        if (val) {
          this.regraTipoEntidade(val);
          if (this.acao === RouteAction.Editar) {
            this.vinculoSuplente(typeof val === 'object' ? val?.id : val);
          }
        } else {
          this.tipoEntidadeIdSelecionada = undefined;
          this.entidadeAndTipoEntidade = undefined;
          this.regraEstatutario();
        }
      });

    this.justificativaFimMandato?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((justificativaFimMandato) => {
        if (justificativaFimMandato) {
          this.isShowJustificativaFimMandato = true;
          this.vinculoForm
            .get('justificativaFimMandato')
            ?.setValidators([Validators.required]);
        } else {
          this.vinculoForm.get('justificativaFimMandato')?.clearValidators();
        }
      });

    this.justificativaFimVinculo?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((justificativaFimVinculo) => {
        if (justificativaFimVinculo) {
          this.isShowJustificativaFimVinculo = true;
          this.vinculoForm
            .get('justificativaFimVinculo')
            ?.setValidators([Validators.required]);
        } else {
          this.vinculoForm.get('justificativaFimVinculo')?.clearValidators();
        }
      });
  }

  private checkUrl() {
    this.route.data.subscribe((data) => {
      this.acao = data['acao'];
      this.inserir = this.acao == RouteAction.Inserir;
      this.editar = this.acao == RouteAction.Editar;
      this.visualizar = this.acao == RouteAction.Visualizar;
    });
  }

  private monitorarMudancasCargoReferencia(): void {
    this.vinculoForm
      .get('cargoReferenciaIds')
      ?.valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((cargoReferenciaIds: any) => {
        this.onCargoReferenciaChange(cargoReferenciaIds);
      });
  }

  dataEmMandato(trocouTipoVinculo?: boolean) {
    const params = this.route.snapshot.params['id'];
    const tipoMandato =
      this.vinculoForm.get('tipoVinculoId')?.value == TipoVinculoEnum.Mandato;
    const entidadeId = this.vinculoForm.get('entidadeId')?.value;

    if ((!params || trocouTipoVinculo) && entidadeId && tipoMandato) {
      const tipoJaConhecido = this.tipoEntidadeIdSelecionada;
      const aplicarMandato = (tipoEntidadeId: number | undefined) => {
        const tiposEntidadesPermitidas = [
          TipoEntidadeEnum.Comissao,
          TipoEntidadeEnum.Subcomissao,
          TipoEntidadeEnum.GrupoTrabalho,
          TipoEntidadeEnum.Orgao,
        ].includes(tipoEntidadeId as TipoEntidadeEnum);

        if (!tiposEntidadesPermitidas) {
          return;
        }

        this.vinculoService
          .entidadeMandato(entidadeId)
          .subscribe((data: any) => {
            const dataInicioMandato = data[0]?.dataInicioMandato;
            const dataFimMandato = data[0]?.dataFimMandato;

            this.dataInicioMandatoControl?.setValue(
              dataInicioMandato ?? null,
            );

            this.dataFimMandatoControl?.setValue(dataFimMandato ?? null);

            if (!dataInicioMandato && !dataFimMandato) {
              this.messageService.warning(
                'A data de mandato não existe para essa entidade. por favor entre em contato com o administrador do sistema.',
              );
            }
          });
      };

      if (tipoJaConhecido != null) {
        aplicarMandato(tipoJaConhecido);
      } else {
        this.entidadeService.getTipoEntidadeById(entidadeId).subscribe((data: any) => {
          aplicarMandato(data?.tipoEntidadeId != null ? Number(data.tipoEntidadeId) : undefined);
        });
      }
    }
  }

  mostrarInputLotacao() {
    const isLotacao =
      this.vinculoForm.get('tipoVinculoId')?.value == TipoVinculoEnum.Lotacao;
    if (isLotacao) {
      this.garantirLotacoesCarregadas();
    }
    return isLotacao;
  }

  seMandadoAddData() {
    this.tipoDoVinculoSelecionado =
      this.vinculoForm.get('tipoVinculoId')?.value;
    this.regraTipoEntidadeEtipoVinculo();
    this.regraComissaoSubcomissaoGrupoTrabalho();
    this.regraComissaoSubcomissaoGrupoTrabalhoMandato();
    this.regraEstatutario();

    if (
      this.vinculoForm.get('tipoVinculoId')?.value == TipoVinculoEnum.Mandato
    ) {
      this.dataEmMandato(true);
    } else {
      this.dataInicioMandatoControl?.reset();
      this.dataFimMandatoControl?.reset();
    }
  }

  private onCargoReferenciaChange(cargoReferenciaIds: any): void {
    const entidadeId = this.vinculoForm.get('entidadeId')?.value;

    // Limpa a lista por padrão para casos onde a validação falhe
    if (!this.possuiCargoSuplenteSelecionado(cargoReferenciaIds) || !entidadeId) {
      this.vinculosEfetivosList = [];
      this.vinculoForm.get('vinculoEfetivoSuplenteId')?.reset();
      return;
    }

    // Busca os vínculos efetivos se todas as condições forem atendidas
    this.vinculoSuplente(entidadeId);
  }

  private possuiCargoSuplenteSelecionado(cargoReferenciaIds: any): boolean {
    const ids = Array.isArray(cargoReferenciaIds)
      ? cargoReferenciaIds
      : cargoReferenciaIds
        ? [cargoReferenciaIds]
        : [];

    return ids.some((cargoId) =>
      this.cargoVinculosList.some(
        (item) => item.id === cargoId && item.suplente,
      ),
    );
  }

  private sincronizarCargosSelecionados(
    cargosSelecionados: number[],
    data: any[],
  ): void {
    const cargosDisponiveisIds = new Set((data ?? []).map((item: any) => item.id));
    const cargosMantidos = (cargosSelecionados ?? []).filter((cargoId: number) =>
      cargosDisponiveisIds.has(cargoId),
    );

    this.cargoReferenciaIdsControl?.setValue(cargosMantidos, {
      emitEvent: false,
    });
  }

  private vinculoSuplente(entidadeId: any): void {
    if (entidadeId) {
      this.vinculoService.listarPorVinculoEfetivo(entidadeId).subscribe(
        (data) => {
          this.vinculoEfetivoSuplente = !this.vinculoEfetivoSuplente
            ? this.vinculoEfetivoSuplenteIdControl?.value
            : this.vinculoEfetivoSuplente;

          this.vinculosEfetivosList = data?.length ? data : [];
          const vinculoEfetivoSuplenteId = data.find(
            (item: any) => item?.idVinculo == this.vinculoEfetivoSuplente,
          );

          this.vinculoForm
            .get('vinculoEfetivoSuplenteId')
            ?.setValue(vinculoEfetivoSuplenteId?.idVinculo);
        },
        () => (this.vinculosEfetivosList = []),
      );
    }
  }

  selectCargos(item: any) {
    if (item) {
      const cargosSelecionados = this.cargoReferenciaIdsControl?.value ?? [];
      this.entidadeSemCargos = false;

      // CNSG-875: atualiza o tipo a partir do combo imediatamente (evita cache stale)
      // enquanto a API de tipo confirma o valor.
      const tipoDoCombo = this.entidadeList?.find(
        (entidade) => Number(entidade.id) === Number(item),
      )?.tipoEntidadeId ?? this.vinculo?.tipoEntidadeId;
      if (tipoDoCombo != null) {
        this.tipoEntidadeIdSelecionada = Number(tipoDoCombo);
        this.entidadeAndTipoEntidade = { tipoEntidadeId: this.tipoEntidadeIdSelecionada };
        this.regraEstatutario();
        this.regraTipoEntidade(this.entidadeIdControl?.value ?? item);
        setTimeout(() => {
          this.seMandadoAddData();
        });
        this.carregarCargosDaEntidade(item, cargosSelecionados);
        this.vinculoSharedDataService.setNomeEntidadeContato(item);
        return;
      }

      this.entidadeService.getTipoEntidadeById(item).subscribe((data) => {
        // Ignora resposta atrasada se o usuário já trocou a entidade
        if (Number(this.entidadeIdControl?.value) !== Number(item)) {
          return;
        }

        this.entidadeAndTipoEntidade = data;
        this.tipoEntidadeIdSelecionada =
          this.entidadeAndTipoEntidade?.tipoEntidadeId != null
            ? Number(this.entidadeAndTipoEntidade.tipoEntidadeId)
            : undefined;
        this.regraEstatutario();
        if (this.tipoEntidadeIdSelecionada != null) {
          this.regraTipoEntidade(this.entidadeIdControl?.value ?? item);
        }

        setTimeout(() => {
          this.seMandadoAddData();
        });

        this.carregarCargosDaEntidade(item, cargosSelecionados);
      });

      // A chamada do vinculoSharedDataService pode ser feita independentemente
      this.vinculoSharedDataService.setNomeEntidadeContato(item);
    } else {
      this.entidadeSemCargos = false;
      this.tipoEntidadeIdSelecionada = undefined;
      this.entidadeAndTipoEntidade = undefined;
      this.regraEstatutario();
    }
  }

  private carregarCargosDaEntidade(item: any, cargosSelecionados: any[]): void {
    this.carregandoCargos = true;
    this.entidadeService.listarEntidadeCargo(item).subscribe({
      next: (data) => {
        this.cargoVinculosList = data;
        this.entidadeSemCargos = data.length === 0;
        const cargoReferenciaIds =
          this.vinculoForm.get('cargoReferenciaIds')?.value;

        if (cargoReferenciaIds?.length) {
          this.onCargoReferenciaChange(cargoReferenciaIds);
        }
        this.sincronizarCargosSelecionados(cargosSelecionados, data);
        this.carregandoCargos = false;
      },
      error: () => {
        this.carregandoCargos = false;
      },
    });
  }

  regraTipoEntidadeEtipoVinculo(): boolean {
    // CNSG-880: em Lotação, ocultar campos incompatíveis (federação, representada,
    // cargo efetivo, área de atuação, etc.) para qualquer tipo de entidade.
    if (this.tipoDoVinculoSelecionado == TipoVinculoEnum.Lotacao) {
      return (this.isEntidadeOrgaoEvinculoLocatao = false);
    }

    return (this.isEntidadeOrgaoEvinculoLocatao = true);
  }

  regraEstatutario(): boolean {
    const tipoVinculo = Number(
      this.tipoDoVinculoSelecionado ?? this.tipoVinculoIdControl?.value,
    );
    const tipoEntidade = this.obterTipoEntidadeSelecionada();
    // CNSG-875: aparece só em Mandato/Permanente + órgão/área/companhias de mercado
    const tipoVinculoPermite =
      tipoVinculo === TipoVinculoEnum.Mandato ||
      tipoVinculo === TipoVinculoEnum.Permanente;

    this.mostrarCampoEstatutario =
      tipoVinculoPermite && this.entidadePermiteCampoEstatutario(tipoEntidade);
    this.isEstatutario = !this.mostrarCampoEstatutario;

    if (this.mostrarCampoEstatutario) {
      this.validarCampoEstatuario(tipoEntidade);
    } else {
      this.flagEstatutarioControl?.setValue(false, { emitEvent: false });
      this.flagEstatutarioControl?.disable({ emitEvent: false });
    }

    return this.isEstatutario;
  }

  private obterTipoEntidadeSelecionada(): number | undefined {
    const entidadeId = this.entidadeIdControl?.value;
    if (entidadeId == null || entidadeId === '') {
      return undefined;
    }

    const idAtual = Number(entidadeId);

    // Sempre prioriza o tipo da entidade atualmente selecionada no form
    // (evita mostrar Estatutário com tipo antigo em cache — CNSG-875).
    const tipoDoCombo = this.entidadeList?.find(
      (entidade) => Number(entidade.id) === idAtual,
    )?.tipoEntidadeId;
    if (tipoDoCombo != null) {
      return Number(tipoDoCombo);
    }

    if (
      this.entidadeAndTipoEntidade != null &&
      Number(this.entidadeAndTipoEntidade.entidadeId) === idAtual &&
      this.entidadeAndTipoEntidade.tipoEntidadeId != null
    ) {
      return Number(this.entidadeAndTipoEntidade.tipoEntidadeId);
    }

    // Sem tipo confiável da entidade atual: não usa cache antigo (CNSG-875).
    return undefined;
  }

  private entidadePermiteCampoEstatutario(tipoEntidade?: number): boolean {
    if (tipoEntidade == null || Number.isNaN(Number(tipoEntidade))) {
      return false;
    }

    const id = Number(tipoEntidade);
    const idsPermitidos = [
      TipoEntidadeEnum.Orgao,
      TipoEntidadeEnum.Area,
      TipoEntidadeEnum.Seguradora,
      TipoEntidadeEnum.Capitalizacao,
      TipoEntidadeEnum.Saude,
      TipoEntidadeEnum.Previdencia,
      TipoEntidadeEnum.Corretora,
      TipoEntidadeEnum.CompanhiasDoMercado,
    ];
    if (idsPermitidos.includes(id as TipoEntidadeEnum)) {
      return true;
    }

    // Domínio dinâmico: aceita tipo cadastrado como "Companhia de Mercado"
    const nome =
      this.entidadeAndTipoEntidade?.nomeTipoEntidade ??
      this.tipoEntidadeList?.find((tipo) => Number(tipo.id) === id)
        ?.nomeTipoEntidade;
    return this.nomeTipoPermiteCampoEstatutario(nome);
  }

  private nomeTipoPermiteCampoEstatutario(nome?: string | null): boolean {
    const normalizado = this.normalizarNomeTipoEntidade(nome);
    if (!normalizado) {
      return false;
    }

    const nomesPermitidos = [
      'ORGAO',
      'AREA',
      'SEGURADORA',
      'CAPITALIZACAO',
      'SAUDE',
      'PREVIDENCIA',
      'CORRETORA',
      'COMPANHIA DE MERCADO',
      'COMPANHIAS DE MERCADO',
      'COMPANHIA DO MERCADO',
      'COMPANHIAS DO MERCADO',
    ];
    if (nomesPermitidos.includes(normalizado)) {
      return true;
    }
    // Aceita variações cadastradas no domínio (ex.: "Companhias do Mercado")
    return (
      normalizado.includes('COMPANHIA') && normalizado.includes('MERCADO')
    );
  }

  private normalizarNomeTipoEntidade(nome?: string | null): string | null {
    if (!nome) {
      return null;
    }
    return nome
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  regraComissaoSubcomissaoGrupoTrabalho(): boolean {
    if (
      this.tipoEntidadeIdSelecionada == TipoEntidadeEnum.Comissao ||
      this.tipoEntidadeIdSelecionada == TipoEntidadeEnum.Subcomissao ||
      this.tipoEntidadeIdSelecionada == TipoEntidadeEnum.GrupoTrabalho
    ) {
      return (this.isComissaoSubcomissaoGrupoTrabalho = false);
    } else {
      return (this.isComissaoSubcomissaoGrupoTrabalho = true);
    }
  }

  regraComissaoSubcomissaoGrupoTrabalhoMandato(): boolean {
    if (
      this.tipoDoVinculoSelecionado == TipoVinculoEnum.Mandato &&
      (this.tipoEntidadeIdSelecionada == TipoEntidadeEnum.Comissao ||
        this.tipoEntidadeIdSelecionada == TipoEntidadeEnum.Subcomissao ||
        this.tipoEntidadeIdSelecionada == TipoEntidadeEnum.GrupoTrabalho)
    ) {
      this.vinculoForm
        .get('dataFimMandato')
        ?.setValidators([Validators.required]);
      return true;
    } else {
      this.dataFimMandatoControl?.clearValidators();
      return false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isPerfilUsuarioLogado();
    this.buildForm();
    this.registrarSubscriptionsFormulario();

    if (changes['vinculo'] && this.vinculo) {
      this.hidratandoFormulario = true;
      this.statusValidacao = this.vinculo?.status;

      // Opções precisam existir ANTES do valor, senão o nz-select server-search fica no placeholder.
      if (this.vinculo?.entidadeId != null) {
        const nomeEntidade =
          this.vinculo?.nomeEntidade ?? this.vinculo?.entidadeNome ?? String(this.vinculo.entidadeId);
        this.entidadeList = [
          {
            id: Number(this.vinculo.entidadeId),
            nome: nomeEntidade,
            tipoEntidadeId: this.vinculo?.tipoEntidadeId,
          },
        ];
      }

      const pessoaIdNumerico =
        this.vinculo?.idSelectPessoa ??
        (typeof this.vinculo?.pessoaId === 'number' ? this.vinculo.pessoaId : null);

      if (pessoaIdNumerico != null) {
        const nomeLabel = this.vinculo?.nomePessoa ?? String(pessoaIdNumerico);
        this.nomePessoaList = [
          {
            id: Number(pessoaIdNumerico),
            nome: nomeLabel,
            nomeCpf: nomeLabel,
          },
        ];
      }

      this.garantirOpcaoTipoVinculoAtual();

      this.vinculoForm.patchValue(
        {
          ...this.vinculo,
          entidadeId: this.vinculo?.entidadeId != null ? Number(this.vinculo.entidadeId) : null,
          pessoaId: pessoaIdNumerico != null ? Number(pessoaIdNumerico) : null,
          tipoVinculoId:
            this.vinculo?.tipoVinculoId != null ? Number(this.vinculo.tipoVinculoId) : null,
        },
        { emitEvent: false },
      );

      // nz-select só pinta o label depois do *ngFor criar o nz-option.
      this.cdr.detectChanges();
      this.reaplicarValorTipoVinculo();

      const entidadeId = this.vinculo?.entidadeId;
      setTimeout(() => {
        this.reaplicarValorTipoVinculo();
        this.carregarTipoVinculoParaExibicao();

        if (entidadeId != null) {
          this.selectCargos(entidadeId);
        }

        if (pessoaIdNumerico != null) {
          const nomeLabel = this.vinculo?.nomePessoa ?? '';
          this.pessoaService.buscarPorId(pessoaIdNumerico).subscribe((data) => {
            if (!data) {
              return;
            }
            this.nomePessoaList = [
              {
                ...data,
                id: Number(data?.id ?? pessoaIdNumerico),
                nomeCpf: data?.nomeCpf ?? data?.nome ?? nomeLabel,
              },
            ];
            this.pessoaIdControl?.setValue(Number(pessoaIdNumerico), { emitEvent: false });
          });
          this.carregarCombosPessoas(Number(pessoaIdNumerico));
        }

        this.hidratandoFormulario = false;
      });
    }

    this.regraEstatutario();
  }

  buildForm(): void {
    addFormControls(this.vinculoForm, {
      entidadeId: ['', Validators.required],
      pessoaId: [undefined, Validators.required],
      tipoVinculoId: ['', Validators.required],
      cargoReferenciaIds: [[], Validators.required],
      dataInicioMandato: [''],
      dataFimMandato: [''],
      dataInicioVinculo: [''],
      dataFimVinculo: [''],
      federacaoIndicadoraId: [''],
      vinculoEfetivoSuplenteId: [undefined],
      vinculoPessoaCargoEfetivo: [],
      empresaLocacaoTerceiro: [''],
      flagVinculoPrincipal: [{ value: false, disabled: false }],
      areaAtuacaoPessoaEntidadeLotada: [''],
      lotacaoVinculo: [''],
      statusValidacaoId: [''],
      cargoPessoaEntidadeRepresentada: [],
      entidadeRepresentadaId: [''],
      nomeCargo: [''],
      vinculoGrupos: [],
      flagEstatutario: [false],
      justificativaFimMandato: [''],
      justificativaFimVinculo: [''],
    });

    this.vinculoForm.get('cargoPessoaEntidadeRepresentada')?.disable();
    this.statusControl?.disable();
    this.aplicarRestricaoFlagVinculoPrincipal();
  }

  carregarListas(): void {
    if (this.listasCarregadas) {
      return;
    }
    this.listasCarregadas = true;
    this.carregandoListas = true;

    // Lotação só quando o tipo de vínculo for Lotação (evita GET pesado no open)
    forkJoin({
      statusValidacao: this.statusValidacaoService.consultarCombo(),
      nomeFederacao: this.entidadeService.listarPorFederacaoCombo(),
      areaAtuacao: this.areaAtuacaoService.listarAreaAtuacaoCombo(),
    }).subscribe({
      next: ({ statusValidacao, nomeFederacao, areaAtuacao }) => {
        this.statusValidacaoList = statusValidacao;
        this.nomeFederacaoList = nomeFederacao.filter(
          (federacao: any) => federacao.tipoAssociacao === 1,
        );
        this.areaDeAtuacaoList = areaAtuacao;
        this.carregandoListas = false;
      },
      error: () => {
        this.carregandoListas = false;
      },
    });
  }

  private garantirLotacoesCarregadas(): void {
    if (this.lotacaoList?.length) {
      this.carregandoLotacoes = false;
      return;
    }
    if (this.carregandoLotacoes) {
      return;
    }
    this.carregandoLotacoes = true;
    this.lotacaoService.listarLotacoes().subscribe({
      next: (data) => {
        this.lotacaoList = data ?? [];
        this.carregandoLotacoes = false;
      },
      error: () => {
        this.carregandoLotacoes = false;
      },
    });
  }

  /** Garante opção do tipo já salvo antes do filtro por tipo de entidade. */
  private carregarTipoVinculoParaExibicao(): void {
    this.obterTiposVinculo((data) => {
      this.tipoVinculoList = data ?? [];
      this.garantirOpcaoTipoVinculoAtual();
      this.cdr.detectChanges();
      this.reaplicarValorTipoVinculo();
    });
  }

  private garantirOpcaoTipoVinculoAtual(): void {
    const tipoId = this.vinculo?.tipoVinculoId ?? this.tipoVinculoIdControl?.value;
    if (tipoId == null || tipoId === '') {
      return;
    }
    const id = Number(tipoId);
    const nome =
      this.vinculo?.nomeTipoVinculo ??
      this.tipoVinculoList.find((item) => Number(item?.id) === id)?.nomeTipoVinculo ??
      String(id);
    if (!this.tipoVinculoList.some((item) => Number(item?.id) === id)) {
      this.tipoVinculoList = [{ id, nomeTipoVinculo: nome }, ...this.tipoVinculoList];
    }
  }

  private reaplicarValorTipoVinculo(): void {
    const tipoId = this.vinculo?.tipoVinculoId ?? this.tipoVinculoIdControl?.value;
    if (tipoId == null || tipoId === '') {
      return;
    }
    this.tipoVinculoIdControl?.setValue(Number(tipoId), { emitEvent: false });
  }

  private obterTiposVinculo(callback: (data: any[]) => void): void {
    if (this.tipoVinculoListCompleta?.length) {
      callback(this.tipoVinculoListCompleta);
      return;
    }
    this.vinculoService.listarPorTipoVinculo().subscribe((data) => {
      this.tipoVinculoListCompleta = data ?? [];
      callback(this.tipoVinculoListCompleta ?? []);
    });
  }

  emitirAlteracaoFormulario() {
    if (this.vinculoForm.dirty) {
      const objEnvioForm = { ...this.vinculoForm.getRawValue() };
      const camposData = [
        'dataInicioMandato',
        'dataFimMandato',
        'dataInicioVinculo',
        'dataFimVinculo',
      ];

      camposData.forEach((campo) => {
        if (objEnvioForm[campo]) {
          objEnvioForm[campo] = dayjs(objEnvioForm[campo]).format(
            'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
          );
        }
      });

      const invalidFields = Object.keys(this.vinculoForm.controls).filter(
        (field) => this.vinculoForm.get(field)?.invalid,
      );
      invalidFields.forEach(
        (field) => (objEnvioForm[field] = this.vinculoForm.get(field)?.value),
      );

      let objEnvio = {
        form: objEnvioForm,
        invalidFields: invalidFields,
      };

      // console.log('objEnvio', objEnvio);

      this.dadosBasicosEmit.emit(objEnvio);
    }
  }

  loadEntidadesSuperior(value: string): void {
    this.buscaPessoaDebounced.run(value, (termo) =>
      this.pessoaService.pessoaVinculoComboPaginado(termo).subscribe((data) => {
        this.nomePessoaList = data;

        const nomePessoaSelectId = this.nomePessoaList.find(
          (pessoa) => pessoa?.nome === termo,
        )?.id;

        // Só seta se for match exato e o control ainda não for o id numérico
        if (
          nomePessoaSelectId &&
          this.pessoaIdControl?.value !== nomePessoaSelectId &&
          typeof this.pessoaIdControl?.value !== 'number'
        ) {
          this.pessoaIdControl?.setValue(nomePessoaSelectId);
        }
      }));
  }

  loadEntidadeCombo(value: string): void {
    this.buscaEntidadeDebounced.run(value, (termo) =>
      this.entidadeService.entidadeComboPaginado(termo).subscribe((data) => {
        this.entidadeList = data ?? [];
      }));
  }

  carregarCombosPessoas(nomePessoaId?: number) {
    if (!nomePessoaId || this.ultimaPessoaComboId === nomePessoaId) {
      return;
    }
    this.ultimaPessoaComboId = nomePessoaId;
    this.carregandoCombosPessoa = true;
    forkJoin({
      representante: this.entidadeService.entidadeRepresentanteCombo(nomePessoaId),
      cargo: this.vinculoService.listarCargoRepresentanteCombo(nomePessoaId),
    }).subscribe({
      next: ({ representante, cargo }) => {
        this.entidadeRepresentanteList = representante;
        this.cargoPessoaEntidadeRepresentadaList = cargo;
        this.carregandoCombosPessoa = false;
      },
      error: () => {
        this.carregandoCombosPessoa = false;
      },
    });
  }

  carregarCombosPessoasFn(value: any) {
    const nomePessoaId =
      typeof value === 'number'
        ? value
        : this.nomePessoaList.find((nome) => nome.id === value)?.id;
    if (nomePessoaId) {
      this.carregarCombosPessoas(nomePessoaId);
    }
  }

  //todo: se o cargo pessoa for de suplente então buscar o vinculo Efetivo
  loadVinculoEfetivo(item: any, value: number): void {
    this.vinculoService
      .listarPorVinculoEfetivo(value)
      .subscribe((data) => (this.vinculosEfetivosList = data));
  }

  compareFn(a: any, b: any): any {
    if (
      typeof a === 'boolean' &&
      (typeof b === 'string' || typeof b === 'boolean')
    ) {
      b = b === 'true';
    } else if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    } else if (a && b?.nome) {
      return a === b.nome;
    }

    if (a && b?.id) {
      return a === b?.id;
    } else if (a?.id && b) return a.id === b;
    else {
      return a === b;
    }
  }

  // regrasDeTipoVinulo(): void {
  //   this.tipoVinculoIdControl?.valueChanges.subscribe(val => {
  //     (val == TipoVinculoEnum.Lotacao)
  //       ? this.empresaLocacaoTerceiroControl?.setValidators([Validators.required])
  //       :this.empresaLocacaoTerceiroControl?.clearValidators();

  //     this.empresaLocacaoTerceiroControl?.updateValueAndValidity();
  //   });
  // }

  regrasDeTipoVinulo(): void {
    if (this.acao == RouteAction.Editar) {
      this.tipoVinculoIdControl?.enable();
    }

    this.tipoVinculoIdControl?.valueChanges.subscribe((val) => {
      this.resetHiddenFields();

      switch (val) {
        case TipoVinculoEnum.Lotacao:
          this.regrasLotacao();

          if (this.perfilUsuarioLogado == PerfilEnum.Atualizador) {
            if (this.tipoVinculoIdControl?.enabled) {
              this.tipoVinculoIdControl.disable({ emitEvent: false });
            }
          }
          break;

        case TipoVinculoEnum.Permanente:
          this.regrasPermanente();
          break;

        case TipoVinculoEnum.Mandato:
          this.regrasMandato();
          break;

        case TipoVinculoEnum.Temporario:
          this.regrasTemporario();
          break;

        default:
          // Clear validators for all controls if none of the above matches
          // this.clearAllValidators();
          this.resetHiddenFields();
          break;
      }

      this.updateAllValidators();
    });
  }

  regrasMandato() {
    let requiredFields = <any>[];

    requiredFields = [
      'entidadeId',
      'nomeCargo',
      'pessoaId',
      'tipoVinculoId',
      'cargoReferenciaIds',
      'dataInicioVinculo',
      'dataInicioMandato',
    ];

    if (
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Comissao ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Subcomissao ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.GrupoTrabalho
    ) {
      //const concat = ['dataInicioMandato', 'dataFimMandato'];
      //requiredFields.push(...concat);
      const limparCampos = [
        'dataFimVinculo',
        'entidadeRepresentadaId',
        'cargoPessoaEntidadeRepresentada',
        'empresaLocacaoTerceiro',
      ];

      clearCamposObrigatorios(limparCampos, this.vinculoForm);

      this.isHiddenFieldsMandatoComissaoSubComissaoGrupoTrabalho = false;
    }

    if (this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Orgao) {
      this.isHiddenFieldsMandatoOrgao = false;
    }

    validarCamposObrigatoriosAjuste(requiredFields, this.vinculoForm);

    // this.dataFimVinculoControl?.valueChanges.subscribe(val => {
    //   if (val) {
    //     this.dataFimMandatoControl?.setValue(val);
    //   }
    // });
  }

  regrasPermanente() {
    let requiredFields = <any>[];

    requiredFields = [
      'entidadeId',
      'nomeCargo',
      'pessoaId',
      'tipoVinculoId',
      'cargoReferenciaIds',
      'dataInicioVinculo',
    ];

    if (
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Comissao ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Subcomissao ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.GrupoTrabalho
    ) {
      this.isHiddenFieldsPermanenteComissaoSubComissaoGrupoTrabalho = false;

      const limparCampos = ['dataFimVinculo', 'entidadeRepresentadaId'];
      clearCamposObrigatorios(limparCampos, this.vinculoForm);
    }

    if (this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Orgao) {
      this.isHiddenFieldsPermanentOrgao = false;
    }

    if (
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Sindicato ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Seguradora ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Corretora ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Capitalizacao ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Saude ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Previdencia
    ) {
      this.isHiddenFieldsPermanenteAssociados = false;
    }

    validarCamposObrigatoriosAjuste(requiredFields, this.vinculoForm);

    this.dataInicioMandatoControl?.clearValidators();
  }

  regrasTemporario() {
    let requiredFields = <any>[];

    requiredFields = [
      'entidadeId',
      'nomeCargo',
      'pessoaId',
      'tipoVinculoId',
      'cargoReferenciaIds',
      'dataInicioVinculo',
    ];

    if (
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Comissao ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Subcomissao ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.GrupoTrabalho
    ) {
      this.isHiddenFieldsTemporarioComissaoSubComissaoGrupoTrabalho = false;

      const concat = [
        'dataFimVinculo',
        'entidadeRepresentadaId',
        'cargoPessoaEntidadeRepresentada',
        'empresaLocacaoTerceiro',
      ];
      requiredFields.push(...concat);

      /*const limparCampos = [
        'dataFimVinculo',
      ];

      clearCamposObrigatorios(limparCampos, this.vinculoForm);*/
    }

    if (
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Sindicato ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Seguradora ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Corretora ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Capitalizacao ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Saude ||
      this.tipoEntidadeIdSelecionada === TipoEntidadeEnum.Previdencia
    ) {
      this.isHiddenFieldsTemporarioAssociados = false;
    }

    validarCamposObrigatoriosAjuste(requiredFields, this.vinculoForm);

    // this.entidadeRepresentadaIdControl?.clearValidators();
    // this.cargoPessoaEntidadeRepresentadaControl?.clearValidators();
    // this.isHiddenFieldsTemporario = false;
  }

  regrasLotacao() {
    let requiredFields = <any>[];

    requiredFields = [
      'entidadeId',
      'nomeCargo',
      'pessoaId',
      'tipoVinculoId',
      'cargoReferenciaIds',
      'dataInicioVinculo',
    ];

    // CNSG-880: sempre ocultar campos incompatíveis com Lotação
    // (federação, entidade/cargo representada, empresa temporário, cargo efetivo, área).
    this.isHiddenFieldsLotacao = false;
    this.isEntidadeOrgaoEvinculoLocatao = false;
    this.limparCamposIncompativeisLotacao();

    validarCamposObrigatoriosAjuste(requiredFields, this.vinculoForm);
  }

  private limparCamposIncompativeisLotacao(): void {
    const campos = [
      'federacaoIndicadoraId',
      'entidadeRepresentadaId',
      'cargoPessoaEntidadeRepresentada',
      'empresaLocacaoTerceiro',
      'vinculoEfetivoSuplenteId',
      'areaAtuacaoPessoaEntidadeLotada',
    ];

    campos.forEach((campo) => {
      const control = this.vinculoForm.get(campo);
      control?.reset(null, { emitEvent: false });
      control?.clearValidators();
      control?.updateValueAndValidity({ emitEvent: false });
    });
  }

  resetHiddenFields() {
    this.isHiddenFieldsMandato = true;
    this.isHiddenFieldsPermanente = true;
    this.isHiddenFieldsTemporario = true;
    this.isHiddenFieldsMandatoComissaoSubComissaoGrupoTrabalho = true;
    this.isHiddenFieldsTemporarioComissaoSubComissaoGrupoTrabalho = true;
    this.isHiddenFieldsPermanenteComissaoSubComissaoGrupoTrabalho = true;
    this.isHiddenFieldsMandatoOrgao = true;
    this.isHiddenFieldsPermanentOrgao = true;
    this.isHiddenFieldsLotacao = true;
    this.isHiddenFieldsPermanenteAssociados = true;
    this.isHiddenFieldsTemporarioAssociados = true;
  }

  clearAllValidators(): void {
    this.dataInicioMandatoControl?.clearValidators();
    this.dataFimMandatoControl?.clearValidators();
    this.empresaLocacaoTerceiroControl?.clearValidators();
    this.entidadeRepresentadaIdControl?.clearValidators();
    this.cargoPessoaEntidadeRepresentadaControl?.clearValidators();
    this.areaAtuacaoPessoaEntidadeLotadaControl?.clearValidators();
    this.lotacaoVinculoControl?.clearValidators();
  }

  updateAllValidators(): void {
    this.dataInicioMandatoControl?.updateValueAndValidity();
    this.dataFimMandatoControl?.updateValueAndValidity();
    this.empresaLocacaoTerceiroControl?.updateValueAndValidity();
    this.entidadeRepresentadaIdControl?.updateValueAndValidity();
    this.cargoPessoaEntidadeRepresentadaControl?.updateValueAndValidity();
    this.areaAtuacaoPessoaEntidadeLotadaControl?.updateValueAndValidity();
    this.lotacaoVinculoControl?.clearValidators();
  }

  validarDatasMandato(): void {
    if (this.acao === RouteAction.Editar) {
      const dataInicio = this.dataInicioMandatoControl?.value;
      const dataFim = this.dataFimMandatoControl?.value;

      if (dataInicio && dataFim) {
        const inicio = dayjs(dataInicio);
        const fim = dayjs(dataFim);

        // Validar se a data de início é maior que a de fim
        if (inicio.isAfter(fim)) {
          // console.log('Erro: Data de início do mandato é maior que a data de fim');
          this.messageService.error(
            'A data de início não pode ser maior que a data de término!',
          );
          this.dataFimMandatoControl.reset();
        } else {
          // console.log('Validação de datas do mandato concluída com sucesso');
        }
      }
    }
  }

  validaJustificativaVinculo(): void {
    if (this.acao === RouteAction.Editar) {
      this.validarJustificativa(
        this.dataFimVinculoControl?.value,
        this.fimVinculo,
        'justificativaFimVinculo',
        (status) => (this.isShowJustificativaFimVinculo = status),
        this.validarDatasVinculo.bind(this),
      );
    }
  }

  validaJustificativaMandato(): void {
    if (this.acao === RouteAction.Editar) {
      this.validarJustificativa(
        this.dataFimMandatoControl?.value,
        this.fimMandato,
        'justificativaFimMandato',
        (status) => (this.isShowJustificativaFimMandato = status),
        this.validarDatasMandato.bind(this),
      );
    }
  }

  private validarJustificativa(
    dataControl: any,
    dataReferencia: any,
    justificativaField: string,
    setShowJustificativa: (status: boolean) => void,
    callbackValidacao: () => void,
  ): void {
    // Resetando validações iniciais
    setShowJustificativa(false);
    const justificativaControl = this.vinculoForm.get(justificativaField);
    justificativaControl?.clearValidators();

    if (!this.isFormInitialized) {
      // console.log('Formulário ainda não inicializado. Ignorando validação.');
      return;
    }

    // console.log(`Iniciando validação de justificativa para ${justificativaField}`);

    // Se ambos os valores são nulos, indefinidos ou vazios
    if (!dataControl && !dataReferencia) {
      // console.log('Ambos os valores são nulos, indefinidos ou vazios. Nenhuma justificativa necessária.');
      return;
    }

    // Se um dos valores for nulo/indefinido ou as datas forem diferentes
    if (
      !dataControl ||
      !dataReferencia ||
      !this.compararDatas(dataControl, dataReferencia)
    ) {
      // console.log('Valor alterado ou inválido. Justificativa necessária.');
      setShowJustificativa(true);
      justificativaControl?.setValidators([Validators.required]);
    } else {
      // console.log('Valores não foram alterados.');
    }

    callbackValidacao();
  }

  private compararDatas(data1: any, data2: any): boolean {
    const data1Normalizada = dayjs(data1).startOf('day');
    const data2Normalizada = dayjs(data2).startOf('day');
    return data1Normalizada.isSame(data2Normalizada);
  }

  validarDatasVinculo(): void {
    const dataInicio = this.dataInicioVinculoControl?.value;
    const dataFim = this.dataFimVinculoControl?.value;

    if (dataInicio && dataFim) {
      const inicio = dayjs(dataInicio);
      const fim = dayjs(dataFim);

      // Validar se a data de início é maior que a de fim
      if (inicio.isAfter(fim)) {
        // console.log('Erro: Data de início do vínculo é maior que a data de fim');
        this.messageService.error(
          'A data de início não pode ser maior que a data de término!',
        );
        this.dataFimVinculoControl?.reset();
        return;
      }
    }
  }
  validarLimiteDatas(): void {
    const dataInicio = this.dataInicioVinculoControl?.value;
    const dataFim = this.dataFimVinculoControl?.value;

    // Verifica se as datas não são null ou undefined antes de chamar o serviço
    if (dataInicio && dataFim) {
      const dataInicioISO = this.formatarDataISO(dataInicio);
      const dataFimISO = this.formatarDataISO(dataFim);

      this.parametrizacaoService
        .validarLimiteDatas(dataInicioISO, dataFimISO)
        .subscribe(
          (response: any) => {
            // Verifica se a resposta contém a chave 'mensagem' e compara com a mensagem de erro
            if (
              response &&
              response.mensagem &&
              response.mensagem.includes('Intervalo excede o limite permitido.')
            ) {
              this.messageService.error(
                'O período do vínculo não pode ser superior a 24 meses!',
              );
              this.dataFimVinculoControl?.reset();
            }
          },
          (error) => {
            console.error('Erro ao validar limite de datas:', error);
          },
        );
    } else {
      // console.log('Datas inválidas ou não definidas, a chamada ao serviço foi ignorada.');
    }
  }

  private formatarDataISO(date: Date): string {
    return dayjs(date).format('YYYY-MM-DD');
  }

  validarCamposObrigatorios(requiredFields: any[]): void {
    requiredFields.forEach((field) => {
      const control = this.vinculoForm.get(field);
      if (control) {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      }
    });
  }

  validaForm() {
    this.vinculoForm.markAllAsTouched();
    this.formService.validateAllFormFields(this.vinculoForm);
  }

  onInputDateChange(inputValue: any, campo: string): void {
    dataComDigitacao(inputValue, this.vinculoForm, campo);
  }

  validarCampoEstatuario(idTipoEntidade?: number) {
    const podeEditar =
      (this.perfilUsuarioLogado === PerfilEnum.Administrador ||
        this.perfilUsuarioLogado === PerfilEnum.Validador) &&
      this.acao !== RouteAction.Visualizar &&
      this.entidadePermiteCampoEstatutario(idTipoEntidade);

    if (podeEditar) {
      this.flagEstatutarioControl?.enable({ emitEvent: false });
    } else {
      this.flagEstatutarioControl?.disable({ emitEvent: false });
    }
  }

  regraTipoEntidade(val: number) {
    // const tipoEntidadeId = this.entidadeList.find(entidade => entidade.id === val)?.tipoEntidadeId;
    const entidade = this.entidadeList.find(
      (item) => Number(item.id) === Number(val),
    );
    const tipoEntidadeIdSelecionada =
      entidade?.tipoEntidadeId != null
        ? Number(entidade.tipoEntidadeId)
        : undefined;
    this.tipoEntidadeIdSelecionada = tipoEntidadeIdSelecionada;
    this.validarCampoEstatuario(tipoEntidadeIdSelecionada);
    this.regraEstatutario();

    this.isHiddenAreaAtuacao = true;

    if (
      tipoEntidadeIdSelecionada === TipoEntidadeEnum.Comissao ||
      tipoEntidadeIdSelecionada === TipoEntidadeEnum.Orgao ||
      tipoEntidadeIdSelecionada === TipoEntidadeEnum.GrupoTrabalho
    ) {
      this.isHiddenAreaAtuacao = false;
    }

    this.obterTiposVinculo((data) => {
      this.tipoEntidadeIdSelecionada = tipoEntidadeIdSelecionada;

      if (
        tipoEntidadeIdSelecionada === TipoEntidadeEnum.Comissao ||
        tipoEntidadeIdSelecionada === TipoEntidadeEnum.Subcomissao ||
        tipoEntidadeIdSelecionada === TipoEntidadeEnum.GrupoTrabalho
      ) {
        this.tipoVinculoList = data.filter((vinculo: { id: number }) =>
          [
            TipoVinculoEnum.Mandato,
            TipoVinculoEnum.Permanente,
            TipoVinculoEnum.Temporario,
          ].includes(vinculo.id),
        );
      } else if (tipoEntidadeIdSelecionada === TipoEntidadeEnum.Orgao) {
        this.tipoVinculoList = data.filter((vinculo: { id: number }) =>
          [
            TipoVinculoEnum.Mandato,
            TipoVinculoEnum.Permanente,
            TipoVinculoEnum.Lotacao,
          ].includes(vinculo.id),
        );
      } else if (
        tipoEntidadeIdSelecionada === TipoEntidadeEnum.Confederacao ||
        tipoEntidadeIdSelecionada === TipoEntidadeEnum.Federacao
      ) {
        this.tipoVinculoList = data.filter((vinculo: { id: number }) =>
          [
            TipoVinculoEnum.Permanente,
            TipoVinculoEnum.Temporario,
            this.tipoVinculoIdControl?.value,
          ].includes(vinculo.id),
        );
      } else if (
        tipoEntidadeIdSelecionada === TipoEntidadeEnum.Sindicato ||
        tipoEntidadeIdSelecionada === TipoEntidadeEnum.Seguradora ||
        tipoEntidadeIdSelecionada === TipoEntidadeEnum.Corretora ||
        tipoEntidadeIdSelecionada === TipoEntidadeEnum.Capitalizacao ||
        tipoEntidadeIdSelecionada === TipoEntidadeEnum.Saude ||
        tipoEntidadeIdSelecionada === TipoEntidadeEnum.Previdencia
      ) {
        this.tipoVinculoList = data.filter((vinculo: { id: number }) =>
          [TipoVinculoEnum.Permanente, TipoVinculoEnum.Temporario].includes(
            vinculo.id,
          ),
        );
      } else if (this.perfilUsuarioLogado == PerfilEnum.Atualizador) {
        this.tipoVinculoList = data.filter(
          (vinculo: { id: number; nomeTipoVinculo: string }) =>
            vinculo.nomeTipoVinculo !== 'Lotação',
        );
      } else {
        this.tipoVinculoList = data;
      }

      this.garantirOpcaoTipoVinculoAtual();
      this.cdr.detectChanges();
      this.reaplicarValorTipoVinculo();

      this.regraEstatutario();
    });
  }

  isFieldRequired(fieldName: string): boolean {
    const control = this.vinculoForm.get(fieldName);
    return control?.hasValidator(Validators.required) || false;
  }

  isPerfilUsuarioLogado() {
    this.perfilUsuarioLogado =
      this.authenticationService.currentUserValue?.perfil?.perfil;
  }

  private aplicarRestricaoFlagVinculoPrincipal(): void {
    const perfisPermitidos = [PerfilEnum.Administrador, PerfilEnum.Atualizador];

    if (perfisPermitidos.includes(this.perfilUsuarioLogado)) {
      this.flagVinculoPrincipalControl?.enable({ emitEvent: false });
    } else {
      this.flagVinculoPrincipalControl?.disable({ emitEvent: false });
    }
  }

  get pessoaIdControl() {
    return this.vinculoForm.get('pessoaId');
  }

  get entidadeIdControl() {
    return this.vinculoForm.get('entidadeId');
  }

  get vinculoEfetivoSuplenteIdControl() {
    return this.vinculoForm.get('vinculoEfetivoSuplenteId');
  }

  get tipoVinculoIdControl() {
    return this.vinculoForm.get('tipoVinculoId');
  }

  get empresaLocacaoTerceiroControl() {
    return this.vinculoForm.get('empresaLocacaoTerceiro');
  }

  get entidadeRepresentadaIdControl() {
    return this.vinculoForm.get('entidadeRepresentadaId');
  }

  get cargoPessoaEntidadeRepresentadaControl() {
    return this.vinculoForm.get('cargoPessoaEntidadeRepresentada');
  }

  get cargoReferenciaIdsControl() {
    return this.vinculoForm.get('cargoReferenciaIds');
  }

  get areaAtuacaoPessoaEntidadeLotadaControl() {
    return this.vinculoForm.get('areaAtuacaoPessoaEntidadeLotada');
  }

  get lotacaoVinculoControl() {
    return this.vinculoForm.get('lotacaoVinculo');
  }

  get dataInicioMandatoControl() {
    return this.vinculoForm.get('dataInicioMandato');
  }

  get dataFimMandatoControl() {
    return this.vinculoForm.get('dataFimMandato');
  }

  get dataInicioVinculoControl() {
    return this.vinculoForm.get('dataInicioVinculo');
  }

  get dataFimVinculoControl() {
    return this.vinculoForm.get('dataFimVinculo');
  }

  ngOnDestroy(): void {
    this.buscaPessoaDebounced.cancelPending();
    this.buscaEntidadeDebounced.cancelPending();
    this.destroy$.next();
    this.destroy$.complete();
  }

  get justificativaFimVinculo() {
    return this.vinculoForm.get('justificativaFimVinculo');
  }

  get justificativaFimMandato() {
    return this.vinculoForm.get('justificativaFimMandato');
  }

  get flagVinculoPrincipalControl() {
    return this.vinculoForm.get('flagVinculoPrincipal');
  }

  get flagEstatutarioControl() {
    return this.vinculoForm.get('flagEstatutario');
  }

  get statusControl() {
    return this.vinculoForm.get('status');
  }
}
